import IDate, { NewDate } from "../Date";

interface IQualification {
    diplomaName: string;
    genesisDate: IDate;
    issuingAuthority: string;
}

export const NewQualification: IQualification = {
    diplomaName: "",
    genesisDate: NewDate,
    issuingAuthority: ""
};

export default IQualification;
